import * as React from 'react';
import { Theme, styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

//Main Page Intro Heading Section
const MainPageLayoutRoot = styled('section')(({ theme }) => ({
	color: theme.palette.common.white,
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	[theme.breakpoints.up('sm')]: {
		height: '80vh',
		minHeight: 500,
		maxHeight: 1300,
	},
}));

const Background = styled(Box)({
	position: 'absolute',
	left: 0,
	right: 0,
	top: 0,
	bottom: 0,
	backgroundSize: 'cover',
	backgroundRepeat: 'no-repeat',
	zIndex: -2,
});

interface MainPageLayoutProps {
	sxBackground: SxProps<Theme>;
}

export const MainPageLayout = (
	props: React.HTMLAttributes<HTMLDivElement> & MainPageLayoutProps,
) => {
	const { sxBackground, children } = props;

	return (
		<MainPageLayoutRoot>
			{/* Display home have message and registration button*/}
			<Container
				sx={{
					mt: 20,
					mb: 14,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				{children}
				<Box
					sx={{
						position: 'absolute',
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
						backgroundColor: 'common.black',
						opacity: 0.5,
						zIndex: -1,
					}}
				/>
				<Background sx={sxBackground} />
			</Container>
		</MainPageLayoutRoot>
	);
};
